module.exports = __webpack_public_path__ + "img/SKMJ_fire3.97140c3a.jpg";